import { useEffect, useState } from "react";
import * as AD from "@radix-ui/react-alert-dialog";
import { Button } from "@/components/ui/button";
import { Trash2, HelpCircle, AlertTriangle } from "lucide-react";

let host = null;
const DESTRUCTIVE_RX = /\b(sil|silin|silme|silinecek|silinsin|kalıcı|kalici|iptal et|kaybol|geri alınamaz)/i;

// window.confirm yerine: await confirm("Mesaj") | await confirm({ title, description, destructive, confirmText })
export function confirm(message, opts = {}) {
  const o = typeof message === "string" ? { description: message, ...opts } : { ...message, ...opts };
  if (o.destructive == null) o.destructive = DESTRUCTIVE_RX.test(`${o.title || ""} ${o.description || ""}`);
  if (!host) return Promise.resolve(window.confirm(o.description || o.title || ""));
  return host(o);
}

export function ConfirmHost() {
  const [st, setSt] = useState(null);
  useEffect(() => { host = (o) => new Promise((resolve) => setSt({ ...o, resolve })); return () => { host = null; }; }, []);
  const close = (v) => { const r = st?.resolve; setSt(null); r?.(v); };
  const destructive = !!st?.destructive;
  const warning = !!st?.warning;
  const Icon = st?.icon || (destructive ? Trash2 : warning ? AlertTriangle : HelpCircle);
  return (
    <AD.Root open={!!st} onOpenChange={(o) => !o && close(false)}>
      <AD.Portal>
        <AD.Overlay className="fixed inset-0 z-[80] bg-slate-950/60 backdrop-blur-[2px] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <AD.Content
          className="fixed left-1/2 top-1/2 z-[80] w-[calc(100vw-2rem)] max-w-md -translate-x-1/2 -translate-y-1/2 rounded-2xl border bg-card shadow-2xl overflow-hidden outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95"
          data-testid="confirm-dialog"
        >
          <div className={`h-1.5 ${destructive ? "bg-destructive" : warning ? "bg-amber-500" : "bg-primary"}`} />
          <div className="p-6">
            <div className="flex items-start gap-4">
              <span className={`h-11 w-11 rounded-xl flex items-center justify-center shrink-0 ${destructive ? "bg-red-50 text-red-600" : warning ? "bg-amber-50 text-amber-600" : "bg-primary/10 text-primary"}`}>
                <Icon className="h-5 w-5" />
              </span>
              <div className="min-w-0 flex-1">
                <AD.Title className="font-head text-lg font-black tracking-tight leading-tight" data-testid="confirm-title">
                  {st?.title || (destructive ? "Silme onayı" : "Onay gerekiyor")}
                </AD.Title>
                <AD.Description className="text-sm text-muted-foreground whitespace-pre-line mt-1.5 leading-relaxed" data-testid="confirm-description">
                  {st?.description}
                </AD.Description>
              </div>
            </div>
            <div className="mt-6 flex flex-col-reverse sm:flex-row sm:justify-end gap-2">
              <Button variant="outline" onClick={() => close(false)} data-testid="confirm-cancel">{st?.cancelText || "Vazgeç"}</Button>
              <Button variant={destructive ? "destructive" : "default"} onClick={() => close(true)} autoFocus data-testid="confirm-ok">
                {st?.confirmText || (destructive ? "Evet, Sil" : "Onayla")}
              </Button>
            </div>
          </div>
        </AD.Content>
      </AD.Portal>
    </AD.Root>
  );
}
